(function () {
  function state(now, zone) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(now).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    const day = Date.UTC(parts.year, parts.month - 1, parts.day);
    const tomorrow = day + 86400000;
    let midnight = tomorrow;
    for (let i = 0; i < 3; i++) {
      const local = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(midnight)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
      midnight += tomorrow - Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
    }
    const seconds = Math.max(0, Math.ceil((midnight - now.getTime()) / 1000));
    const dateFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short' });
    const date = offset => dateFormat.format(new Date(day + offset * 86400000));
    return { seconds, countdown: [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0')).join(':'), dispatch: date(0) + ' - ' + date(1), delivered: date(1) + ' - ' + date(3) };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = state;
  if (typeof document === 'undefined') return;
  window.NamorraDeliveryState = state;
  function init() {
    document.querySelectorAll('[data-nc-delivery]').forEach(root => {
      if (root.dataset.clockReady) return;
      root.dataset.clockReady = 'true';
      const zone = root.dataset.timeZone || 'Europe/London';
      let timer;
      function update() {
        if (!root.isConnected) { clearInterval(timer); return; }
        const timing = state(new Date(), zone);
        const hours = Math.floor(timing.seconds / 3600);
        const minutes = Math.floor(timing.seconds % 3600 / 60);
        const label = hours + ' ' + root.dataset.hoursLabel + ' ' + minutes + ' ' + root.dataset.minutesLabel;
        const counter = root.querySelector('[data-delivery-countdown]');
        if (counter.textContent !== label) counter.textContent = label;
        root.querySelector('[data-countdown-line]').hidden = false;
        root.querySelector('[data-delivery-date]').textContent = timing.delivered;
      }
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) { root.classList.add('nc-timeline-seen'); observer.disconnect(); }
        }, { threshold: 0.35 });
        observer.observe(root);
      }
      update();
      timer = setInterval(update, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();




